import React from 'react'
import GameIcon from './GameIcon'

// Переключатель вкладок игр
// props: games (массив {slug, name}), activeGame (slug), onSelect (callback)
const GameTabs = ({ games, activeGame, onSelect }) => {
  if (!games || games.length === 0) return null

  // Если только одна игра — не показываем переключатель
  if (games.length === 1) return null

  return (
    <div className="flex gap-2 flex-wrap justify-center mb-4">
      {games.map((game) => {
        const isActive = activeGame === game.slug

        return (
          <button
            key={game.slug}
            onClick={() => onSelect(game.slug)}
            className={`flex items-center gap-2 px-3 py-2 rounded-lg font-medium whitespace-nowrap transition-colors ${
              isActive
                ? 'bg-accent-primary text-dark-primary'
                : 'bg-surface text-text-secondary hover:bg-surface/80'
            }`}
          >
            <GameIcon
              game={game.slug}
              size={18}
              className={isActive ? '' : 'opacity-70'}
            />
            <span className="text-sm">{game.name}</span>
          </button>
        )
      })}
    </div>
  )
}

export default GameTabs
